import { HotelReservation } from "@/types/hotelReservation";
import { UserSubscription } from "@/types/userSubscription";
import { PurchasedProduct } from "@/types/purchasedProduct";
import { UserBill } from "@/types/bill";
import { RefundableItem } from "@/types/refundableItem";

// Type guards for RefundableItem using pk prefix
export const isHotelReservation = (
  item: RefundableItem
): item is HotelReservation => item.pk.startsWith("HOTELRES0#");

export const isUserSubscription = (
  item: RefundableItem
): item is UserSubscription => item.pk.startsWith("USERSUB0#");

export const isPurchasedProduct = (
  item: RefundableItem
): item is PurchasedProduct => item.pk.startsWith("PURCHASEDPROD0#");

export const isUserBill = (item: RefundableItem): item is UserBill =>
  item.pk.startsWith("USER_BILL#");

// Utility to get company/platform name
export const getCompanyName = (item: RefundableItem): string => {
  if (isHotelReservation(item)) {
    return item.hotelPlatform || item.hotelName || "Hotel";
  }
  if (isUserSubscription(item)) {
    return item.serviceName || "Service";
  }
  if (isPurchasedProduct(item)) {
    return item.retailer || "Retailer";
  }
  if (isUserBill(item)) {
    return item.provider || "Bill Provider";
  }
  return "Company";
};
